// src/routes/index.js
import AuthRoute from '../modules/Base/Auth/components/AuthRoute';
import AuthPage from '../modules/Base/Auth/pages/authPage';
import HomePage from '../modules/Base/Home/HomePage';
import ProfilePage from '../modules/Base/SettingsPage/SettingsPage';
import UnauthorizedPage from '../modules/Base/Unauthorized/Unauthorized';

const routes = [
  // Public auth routes
  {path: '/',                 element: (<AuthRoute><HomePage /></AuthRoute>),},
  { path: '/login',           element: <AuthPage /> },
  { path: '/register',        element: <AuthPage /> },
  { path: '/unauthorized',    element: <UnauthorizedPage /> },
  {path: '/settings',   element: (<AuthRoute requiredPermissions={[]}><ProfilePage /></AuthRoute>),},
];

export default routes;
